<template>

  <div class="main">

   <!-- ToolBar -->
    <div class="mb-4 pb-3">
      <v-toolbar fixed light dense color="white">
        <v-btn active-class icon light to="/stage1">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>
        <vue-letter-avatar :name="profileinfo.tkname" size="35" :rounded="true" />
        <v-toolbar-title class="tk-name-toolbar header pa-2 ma-0" v-text="profileinfo.tkname"></v-toolbar-title>
        <v-toolbar-title style="font-size: 1.6rem;">(Stage2 : Page Reload Issue)</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn active-class icon to="/stage1">
          <v-tooltip color="blue" nudge-left="40px" bottom>
            <!-- <v-icon slot="activator" color="black" dark>fa fa-paw</v-icon> -->
            <v-icon slot="activator" color="black" dark>fas fa-cat</v-icon>
            <span>Back to Stage1 (Cat Bios List) </span>
          </v-tooltip>
        </v-btn>
        <v-btn active-class icon to="/">
          <v-tooltip color="blue" nudge-left="30px" bottom>
            <v-icon slot="activator" color="black" dark>fa fa-home</v-icon>
            <span>To Main www.timmyskittys.com</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat round icon :href="facebook" target="_blank">
          <v-tooltip color="blue" nudge-left="30px" bottom>
          <v-icon slot="activator" color="black" medium>fab fa-facebook-square</v-icon>
            <span>Visit Us on Facebook</span>
          </v-tooltip>
        </v-btn>
      </v-toolbar>
    </div>

    <v-container grid-list-lg fluid>
      <v-layout wrap justify-center>
        <v-flex>
          <v-card class="pa-2">
            <v-icon class="profilebio pb-1 pr-1" size=".8rem" color="blue">fa fa-circle</v-icon><b>Issue Description & and Recreation:</b><br>
            <p class="pl-3">
              1. Route, stage1 (the previous page you were on), loads data into Vuex (this is in component Stage1.vue on lines 157 - 159).<br>
              <br>
              2. Then, a user clicks on any one of the cards at stage1 (which you did to get to this page/route, stage2). Now, at this point below are some of the options (my steps taken in testing) I have used successfully to get the ID (named tkid) in Stage2.vue which is required in order to pull the respective cat data from the store (pass tkid to the getter to get the data). There are no issues at this point at initial page load of Stage2.vue & and the pull of data from the Vuex store is successful.<br>
              <br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A. <b>Props:</b><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -Passing tkid from Stage1.vue to Stage2.vue as props.<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -When any one of the links are clicked at Stage1.vue it will pass the id (named tkid) to Stage2.vue as a prop. Then Stage2.vue will use the passed id (tkid) to search the store for the specific data for the given page.<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -Note, since the issue is with the reload of the page, the prop (tkid) that is passed to Stage2.vue from Stage1.vue is successful, and the prop (tkid) is used to get the specific data from the store by passing the tkid to the getter. However, a page reload causes tkid to become undefined. I expected this as the reason tkid is undefined at page reload is the prop (tkid) is NOT being passed to stage2 from stage1. This is not the issue, however, and even if I save the prop in localStorage the issue is the same.<br>
              <br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; B. <b>LocalStorage (id = tkid):</b><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -The id is successfully added to LocalStorage at initial page load: localStorage.setItem('tkid', this.$route.params.tkid). This is done in created().<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -The id can be successfully pulled from LocalStorage (at initial page load & page reload) where it is used to search the store for the specific information for the id (tkid). The getter is named getById:  this.getById(localStorage.getItem('tkid')).  Eventhough the tkid is preserved in localStorage, using it at page reload still fails for the pull from Vuex store. Note, getById is the Vuex getter to load the Vuex data for the specific cat given the tkid number.<br>
              <br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; C. <b>$route.params.id:</b><br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -The id (tkid) is successfully assigned the id in the router:  this.tkid = this.$route.params.tkid. This done in created() and is how I'm setting tkid in Stage2.vue for this issue demo.<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -Then, the id (tkid) is used to pull the respective data from the store: this.getById(this.tkid). Same results as localStorage, eventhough the tkid is preserved in the route, using its value at page reload still fails for the pull from Vuex store.<br>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; -Note, doing the following, all in one shot, yields the same results as the above 2 steps: this.getById(this.$route.params.tkid).<br>
              <br>
              3. Now, once route, stage2, has succssfully loaded, <b style="color: red;">Use the Following to Recreate the Issue:</b><br>
              <br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A. Make sure you still have your Dev Tools still open (f12).<br>
              <br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; B. Before starting, note the following output in the console (example listed below). This is from the inital page load of Stage2.vue. If you clicked on the first card it will have the tkid of 1. If you click on another card, that is fine, but the tkid will be the # for that respective cat). If you need to view this info in the console, click back to stage1, clear your console, and re-enter stage2 route (click on a card).<br>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Created - tkid: 1<br>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Profileinfo - this.tkid: 1<br>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Profileinfo - LS: 1<br>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Profileinfo - getById: <i>The entire cats vuex data will display here. An object with a bunch of data.</i><br>
              <br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; C. Next, click your browsers reload button and view the errors in the console. Most specifically this error: <b style="color: red;">Error in render: "TypeError: Cannot read property 'tkname' of undefined"</b>. Note, as shown below, this is the same console output as in step B (above), except in this case getById returns undefined. As noted, the getById is the Vuex getter to load the Vuex data for the specific cat given the tkid number. The reason for the 'tkname' in the error is because it is first property in the object (as pulled from the store) I'm attempting to display in a v-for loop. And, it is undefined because no data was pulled from the store due to this issue (getById is undefined in the console).<br>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Created - tkid: 1<br>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Profileinfo - this.tkid: 1<br>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Profileinfo - LS: 1<br>
                   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Profileinfo - getById: <b>undefined</b>   : <i>Note, this is undefined this time, eventhough the tkid I used to pass to the getter (getById) is defined (this.tkid: 1).</i><br>
              <br>
            </p>

            <v-icon class="profilebio pb-1 pr-1" size=".8rem" color="blue">fa fa-circle</v-icon><b>Given the above, my Questions are:</b><br>
            <p class="pl-3">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1. Why isn't getById pulling the store data at a page reload (why it is undefined)?<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2. What can be done to address this issue?<br>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3. I want to be able to go directly to a specific cats bio using the URL (for example, www.timmyskittys.com/stage2/1). How can this be fixed (or will fixing question 1 address this as well)?<br>
              <br>
            </p>

            <v-icon class="profilebio pb-1 pr-1" size=".8rem" color="blue">fa fa-circle</v-icon><b>Notes on this Issue:</b><br>
            <p class="pl-3">
              1. This issue also occurs when attempt to load the link directly, for example placing the following in your browser and clicking enter will fail with the same issue: www.timmyskittys.com/stage2/1<br>
              2. If I make any changes to the .json file being used for the data, it will cause a reload of the page (Stage2.vue), thus causing the exact same error as above.<br>
              3. At the same time, if you're at the route, stage1 (Stage1.vue), and the .json file is modified, a page reload will also occur with the following warnings indicated in the console (is this related to this issue?):<br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; [HMR] Cannot apply update. Need to do a full reload!<br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; VM6060 log.js:25 [HMR] Error: Aborted because ./src/assets/dbdata.json is not accepted<br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Update propagation: ./src/assets/dbdata.json -> ./src/store/actions.js -> ./src/store/index.js -> ./src/main.js -> 0<br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; at hotApply (http://localhost:8080/app.js:441:30)<br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; at http://localhost:8080/app.js:290:21<br>
              4. My speculation on the issue is that it may have something to do with either routing, the virtual DOM, or hot reloading (a big maybe, see note 2 above, but shouldn't that be only in dev?), or a combo of any of these.<br>
              5. Backend will be MongoDB, but for now using local .json file. However, I believe this issue would still occur as the data in the MongoDB would be stored in Vuex (same as using the .json file). Is this correct?<br>
              6. I also tried using the following packages: None were specific enough for to help address this issue.<br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; * vuex-persist-state<br>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; * vuex-persitedstate<br>
            </p>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout wrap justify-center>

        <!-- Bio Profile Pict -->
        <v-flex xs12 md6 class="pa-0 mb-1 bio-profile-pict" elevation-6>
          <v-card height="100%">
            <v-img height="100%" :src="require(`@/img/${profileinfo.profilepict}`)">
              <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                <v-progress-circular size="60" :width="8" indeterminate color="blue lighten-1"></v-progress-circular>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>

        <!-- Bio Profile Details -->
        <v-flex xs12 md6 class="pa-0 mb-1 bio-border" elevation-6>
          <v-card height="100%" class="pb-2">
            <v-flex xs12>
              <v-card-title><h2 class="black--text tk-bio-name mx-auto">{{ profileinfo.tkname }}'s Bio</h2></v-card-title>
              <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
              <span class="pl-1"><b>Date of Birth:</b> {{profileinfo.dateofbirth}}</span>
              <div v-if="profileinfo.dateofdeath">
                <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                <span class="pl-1"><b>Date of Death:</b> {{profileinfo.dateofdeath}}</span>
              </div>
              <div v-if="profileinfo.locationofbirth">
                <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                <span class="pl-1"><b>I Was Born In:</b> {{profileinfo.locationofbirth}}</span>
              </div>
              <div v-for="(bioitem, index) in profileinfo.bioinfo" :key="index">
                <div v-if="bioitem">
                  <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                  <span class="pl-1" v-html="bioitem"></span>
                </div>
              </div>
              <div>
                <v-icon class="profilebio pb-1" size=".8rem" color="blue">fa fa-circle</v-icon>
                <span class="pl-1">See more of me at the links below </span><v-icon color="blue" size=".9rem" class="pt-1">fas fa-ellipsis-h</v-icon>
              </div>
            </v-flex>
          </v-card>
        </v-flex>

      </v-layout>

        <!-- Inner Cards that provide links to further details -->
        <!--
        <v-layout row wrap class="mt-1">
          <v-flex v-for="card in cards" :key="card.title" xs12 sm4 elevation-6 class="pa-1 bio-links">
            <router-link class="rtlnk" :to="{ name: `${card.link}`, params: { tkid: tkid} }">
              <v-card hover ripple height="100%">
                <v-img :src="card.image" height="100%">
                  <v-layout fill-height>
                    <v-flex xs12 align-end>
                      <v-icon color="black" class="mt-1 ml-1">{{card.icon}}</v-icon>
                      <span class="headline black--text pl-1" v-text="card.title"></span>
                    </v-flex>
                  </v-layout>
                </v-img>
              </v-card>
            </router-link>
          </v-flex>
        </v-layout>
        -->

    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import FooterView from "./FooterView";

export default {
  components: {
    FooterView,
  },
  /*
  props: {
    tkid: {
      type: String,
      required: true
    }
  },
  */
  data: () => ({
    // profileinfo: {},
    tkid: '',
    attrs: '',
    facebook: "https://www.facebook.com/timmyskittys1",
    cards: [
      {
        title: "Pictures",
        link: "TkPictGridView",
        image: require("../img/profile_link_tklink.jpg"),
        icon: 'far fa-images'
      },
      {
        title: "Videos",
        link: "TkVideosView",
        image: require("../img/profile_link_videos.jpg"),
        icon: 'fas fa-video'
      },
      {
        title: "Stories",
        link: "TkStoriesView",
        image: require("../img/profile_link_stories.jpg"),
        icon: 'fas fa-pen-fancy'
      },
    ]
  }),
  computed: {
    ...mapGetters([
      // 'getByName'
      'getById'
    ]),
    profileinfo () {
      // return this.getById(this.$attrs.tkid) //WORKS ON INITIAL PAGE LOAD, BUT NOT ON PAGE RE-LOAD. SAME, tkname undefined

      // The below produces the same results if "this.$route.params.tkid" is used in place of this.tkid in the
      // below examples (like this:  return this.getById(this.$route.params.tkid)  )
      // Works as expected, displays the value for tkid on initial page load AND a page reload:
      console.log("Profileinfo - this.tkid: " + this.tkid)

      // The below produces the same results if "localStorage.getItem('tkid')" is used in place of this.tkid in the
      // below examples (like this: return this.getById(localStorage.getItem('tkid'))  )
      // Works as expected, displays the value for tkid in localStorage on initial page load AND a page reload:
      console.log("Profileinfo - LocalStorage: " + localStorage.getItem('tkid'))

      // This works on initial pae load BUT is 'undefined' on page reload. This causes the first use of profileinfo
      // (in this case profileinfo.tkname) to be 'undefined', and no vuex data loaded. So, something with routing or
      // the Vuex data no longer loaded (TPD):
      // console.log("Profileinfo - getById: " + JSON.stringify(this.getById(this.tkid)))
      console.log("Profileinfo - getById: " + JSON.stringify(this.getById(localStorage.getItem('tkid'))))
      // return this.getById(this.tkid)
      return this.getById(this.tkid)
    }
 },
 /*
 beforeRouteEnter (to, from, next) {
  //  console.log("beforeRouteEnter: " + localStorage.getItem('tkid', to.params.tkid))
   localStorage.setItem('tkid', to.params.tkid)
 },
 */
 // beforeCreate() {
 // mounted() {
 created() {
  // console.log("In Created")
  // console.log("tkid: " + this.tkid)
  // console.log("Route Path: " + this.$route.path) //URL path /tkprofile/<tkid#>
  // console.log("Route Name: " + this.$route.name) //The component name (TkProfileView)
  // console.log("attrs: " + JSON.stringify(this.$attrs.tkid))
  // console.log("attrs: " + this.$attrs.tkid)
  // this.tkid = JSON.stringify(this.$route.params.tkid) //NOT WORKING
  // this.tkid = this.$route.params.tkid //NOT WORKING
  this.tkid =  localStorage.getItem('tkid')
  // this.tkid = this.$route.params.tkid //WORKING in created(). But not on page re-load.
  // this.profileinfo = this.$store.getters.getById(this.$route.params.tkid)  //WORKING ON INITIL PAGE LOAD WITH created(), NOT WORKING with mounted()
  // profileinfo = this.$store.getters.getById(localStorage.getItem('tkid'))
  // this.$set(this.$store.getters.getById(this.tkid), 'tkid', this.$route.params.tkid)
  // console.log("Created getById: " + this.$store.data.find(tkcat => tkcat.tkid === this.$route.params.tkid));
  // localStorage.setItem('tkid', this.$route.params.tkid)
  // this.tkid = this.$route.params.tkid
  // console.log("Created - tkid: " + this.tkid )
 }
};
</script>

<style scoped>
.main {
  background-color: #f8f8ff;
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.toolbar {
  background-color: #f8f8ff;
}
.headline {
  font-weight: bold;
  font-size: 2rem;
  /* Note, font not working */
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
}
.rtlnk {
  list-style-type: none;
  text-decoration: none;
}
.profilepict {
  background-size: cover;
  max-width: 100%;
  height: auto;
}
.profilebio {
  color: #000;
}
.biolayout {
  margin-bottom: 60px;
}
.tk-name-toolbar {
  text-shadow: -2px 2px 3px rgba(0, 0, 0, .3);
}
.bio-profile-pict {
  /* margin-right: 5px; */
  /* border: 1px solid rgba(0, 0, 0, .2); */
  border: 2px solid rgba(255, 255, 255, 1);
  border-radius: 4px;
}
.bio-item-info {
  display: inline-block;
  align-items: center;
  vertical-align: auto;
}
.bio-border {
  /* border: 6px solid transparent; */
  /* border-image: url("../img/border_paws_800x747.jpg") 40 round; */
  border: 4px solid rgba(0, 0, 0, .2);
  border-radius: 4px;
}
.bio-links {
  /* border: 4px solid rgba(0, 0, 0, .2); */
  border-radius: 3px;
}
.header {
  text-transform: capitalize;
  font-size: 2rem;
}
.tk-bio-name {
  text-transform: capitalize;
  font-size: 2rem;
  text-shadow: -2px 2px 3px rgba(0, 0, 0, .3);
}
.tk-bio-name::first-letter {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 3.2rem;
  line-height: 0;
  font-weight: bolder;
  color: black;
  margin-right: 3px;
}
.footer {
  margin-top: 10px;
}
/******** iPads (portrait) *********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .footer {
    margin-top: 20px;
  }
}
/********** iPad 3 (landscape) **********/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 20px;
  }
}
/************ iPad Pro (portrait) ***********/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 0px;
  }
}
/************ iPad Pro (landscape) ***********/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
  .footer {
    margin-top: 0px;
  }
}

/************************************** iPhones *************************************/
@media only screen and (min-device-width: 414px) and (max-device-height: 736px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 20px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 2) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* iPhone X ----------- */
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-height: 812px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* iPhone 6/7/8/X plus ----------- */
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-height: 896px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* Samsung Galaxy S5 ----------- */
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: landscape) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 20px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
@media only screen and (min-device-width: 360px) and (max-device-height: 640px) and (orientation: portrait) and (-webkit-device-pixel-ratio: 3) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* Samsung Galaxy III */
@media screen and (device-width: 360px) and (device-height: 640px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.4rem;
  }
}
/* Nexus */
@media screen and (device-width: 600px) and (device-height: 960px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 1.6rem;
  }
}
/* Amazon Fire HD 8.9 */
@media only screen  and (min-device-width: 1200px) and (max-device-width: 1920px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 2.3rem;
  }
}
/* Amazon Fire HD 8.9 */
@media only screen and (min-device-width: 800px) and (max-device-width: 1.60px) and (orientation: portrait) {
  .footer {
    margin-top: 70px;
  }
  .header {
    text-transform: capitalize;
    font-size: 2.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Stage2.vue